import { WidgetStylesConfiguration } from '@vestico/model';

const defaultConfiguration = (): WidgetStylesConfiguration => {
  return {
    providerDocumentID: '',
    coreColor: '#3000ff',
    entries: [],
  };
};

export class StylesConfig {
  public readonly stylesConfig: WidgetStylesConfiguration;

  constructor(stylesConfiguration?: WidgetStylesConfiguration) {
    if (stylesConfiguration && stylesConfiguration !== undefined) {
      this.stylesConfig = stylesConfiguration;
    } else {
      this.stylesConfig = defaultConfiguration();
    }
  }

  public getCustomizedStyles(): Record<string, string> {
    const styles: Record<string, string> = {};
    const { coreColor, buttonRadius, font } = this.stylesConfig;
    if (coreColor && coreColor !== undefined && typeof coreColor === 'string') {
      styles['--color'] = coreColor;
    }
    if (buttonRadius !== undefined && typeof buttonRadius === 'number') {
      styles['--button-border-radius'] = `${buttonRadius}px`;
    }
    if (font && font !== undefined && typeof font === 'string' && font.length > 0) {
      styles['--font-family'] = font;
    }
    return styles;
  }
}
